import { useMemo } from 'react'

import { useStorage } from './useStorage'

const PathTitles = {
  '/products': 'Shop',
  '/search-results': 'Search Results',
  '/': 'Home',
}

export const usePreviousPath = () => {
  const [previousHref] = useStorage({
    key: 'previousHref',
    type: 'session',
    defaultValue: '',
  })

  return useMemo(() => {
    if (!previousHref) {
      return null
    }

    try {
      const previousUrl = new URL(previousHref)
      const href = previousUrl.pathname + previousUrl.search

      const pathTitle = Object.entries(PathTitles).find(
        ([path]) => previousUrl.pathname === path,
      )?.[1]

      if (!pathTitle) {
        return null
      }

      const category = previousUrl.searchParams.get('category')?.split(',')[0]
      if (category) {
        return {
          href,
          title: decodeURIComponent(category),
        }
      }

      return {
        href,
        title: pathTitle,
      }
    } catch (error) {
      console.error('Error parsing previous state:', error)
      return null
    }
  }, [previousHref])
}
